const { Element, Text } = require('slate');

const isEmptyElement = (element) => {
  if (!Element.isElement(element)) {
    return false;
  }

  const { children } = element;

  if (children.length === 0) {
    return true;
  }

  const [first] = children;

  return (
    children.length === 1 &&
    Text.isText(first) &&
    first.text.replace(/\n|\r/g, '') === '' &&
    element.entity == null
  );
};

module.exports = isEmptyElement;
